import { ApiAddress } from "../apis"
import request from "../request"

export interface IPlanPermission {
  code: string
  description: string
}

export const createPlanPermission = async (planPermission: IPlanPermission) => {
  return await request.post<IPlanPermission>(ApiAddress.PLAN_PERMISSIONS, planPermission)
}

export const getPlanPermissions = async (): Promise<IPlanPermission[]> => {
  return await request.get(ApiAddress.PLAN_PERMISSIONS)
}

export const updatePlanPermission = async (planPermission: IPlanPermission, code: string) => {
  return await request.put<IPlanPermission>(ApiAddress.PLAN_PERMISSION, planPermission, { params: { code } })
}

export const deletePlanPermission = async (code: string) => {
  return await request.delete(ApiAddress.PLAN_PERMISSION, { params: { code } })
}

export const updatePermissionsForPlan = async (id: number, permissions: IPlanPermission[]) => {
  return await request.put(ApiAddress.PERMISSIONS_IN_PLAN, {permissions}, { params: { id } })
}